import React, { Fragment, useContext, useEffect } from 'react';
import { get } from 'lodash';
import { compose } from 'react-apollo';
import tokenStore from 'MoshtixShared/helper-token-store';

import LoadingOverlay from 'ControlRoomComponents/loading-overlay';
import { Header } from 'Components/component-header';
import Footer from 'Components/component-footer';

import { GET_ORDERS_N_ASSIGNED_TICKETS_QUERY } from '../../data-definitions';
import { useQuery } from '../../hooks/helper-apollo-hooks';
import useToLogin from '../../hooks/useToLogin';
import { withHistory } from '../../pages/event/withHistory';

import { history } from '../../app/history';
import { EventPage } from '../../pages/event';
import { TicketDistroContext } from '../../app/contexts';

interface RedirecterProps {
  ticketDialogVisible: boolean;
  onDialogClose?: () => void;
}

const RedirecterWithoutHistory: React.FC<RedirecterProps> = (props) => {
  const { ticketDistroContext } = useContext(TicketDistroContext);
  const params = get(props, 'match.params');
  const isLoggedIn = useToLogin({ params });

  const { data: orderData, loading } = useQuery<{ viewer: {} }>(GET_ORDERS_N_ASSIGNED_TICKETS_QUERY, {
    skip: !isLoggedIn,
    variables: {
      token: tokenStore.getTicketDistroToken(),
    },
  });

  const { setState } = ticketDistroContext.actions;

  useEffect(() => {
    setState({
      dataLoading: loading,
    });
  }, [setState, loading]);

  useEffect(() => {
    // 1. Check if the order query has returned something (the condition from sCU)
    const hasNewOrderData = get(orderData, 'viewer.orders.items', null);

    if (hasNewOrderData) {
      const walkUpMode = get(ticketDistroContext, 'state.walkUpMode', false);

      // 2. Update context state
      setState({
        assignedTickets: get(orderData, 'viewer.assignedTickets'),
        orders: get(orderData, 'viewer.orders'),
        dataLoaded: true,
        dataLoading: false,
        walkUpMode: false,
      });

      // 3. Determine the first event and ticket ID
      const firstEventId =
        get(orderData, 'viewer.orders.items[0].event.id', null) ||
        get(orderData, 'viewer.assignedTickets.items[0].event.id', null);

      const firstTicketId =
        get(orderData, 'viewer.orders.items[0].tickets.items[0].id', null) ||
        get(orderData, 'viewer.assignedTickets.items[0].id', null);

      // 4. Perform the redirection
      if (firstEventId) {
        if (walkUpMode) {
          history.push(`/event/${firstEventId}/ticket/${firstTicketId}`);
        } else {
          history.push(`/event/${firstEventId}`);
        }
      }
    }
  }, [orderData, setState, ticketDistroContext]);

  return (
    <Fragment>
      <LoadingOverlay visible />
      <EventPage />
    </Fragment>
  );
};

export const Redirecter = compose(withHistory)(RedirecterWithoutHistory);
